import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M240-440q-17 0-28.5-11.5T200-480t11.5-28.5T240-520h480q17 0 28.5 11.5T760-480t-11.5 28.5T720-440z" }, null, -1)
  ])))
}
export default { render: render }